import React from "react";

const TitleEditField = ({handleInputChange, formData}) => {


  return (
    <div className={"detail-design-history-title edit"}>
      <label className={"label"}>Title : </label>
      <input type={"text"}
             name={"title"}
             maxLength={50}
             placeholder={"Title"}
             value={formData.title}
             onChange={handleInputChange}
      />
    </div>
  )
}

export default TitleEditField;
